// src/ui/screens/chats/widgets/ArchiveBanner.jsx

import React from 'react';
import { useNavigate } from 'react-router-dom';

const COLORS = {
  orange: '#FF8C08',
  card: '#23262C',
};

// ── ArchiveBanner ─────────────────────────────────────────────────────────────
//
// The single-row entry point to the archive screen that sits at the very top
// of the conversations list — exactly like WhatsApp's "Archived" row.
// Tapping it navigates to the archive view.

export const ArchiveBanner = ({ archivedCount, onTap }) => {
  const handlePress = () => {
    if (onTap) {
      onTap();
    }
  };

  return (
    <button
      onClick={handlePress}
      className="w-full mx-3 my-1 px-4 py-3.5 rounded-xl flex items-center gap-3.5 transition-colors hover:bg-filatom-card-hover"
      style={{
        backgroundColor: COLORS.card,
        border: '0.8px solid rgba(255,255,255,0.06)',
        width: 'calc(100% - 24px)',
      }}
    >
      {/* Archive icon in a tinted circle */}
      <div
        className="w-11 h-11 rounded-full flex items-center justify-center"
        style={{ backgroundColor: `${COLORS.orange}1F` }}
      >
        <svg className="w-5.5 h-5.5 text-filatom-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4" />
        </svg>
      </div>

      {/* Label + count */}
      <div className="flex-1 text-left">
        <p className="text-white text-sm font-semibold">Archived</p>
        <p className="text-white/40 text-xs">
          {archivedCount} {archivedCount === 1 ? 'chat' : 'chats'}
        </p>
      </div>

      {/* Chevron */}
      <svg className="w-5.5 h-5.5 text-white/25" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
      </svg>
    </button>
  );
};

export default ArchiveBanner;